import React, { useEffect, useState } from "react";
import { Box, IconButton, Modal, CircularProgress } from "../../components/ui";
import { Delete } from "../../components/icons";
import { toast } from "react-toastify";
import axiosInstance from "../../axios/axiosInstance";
import { modalStyle } from "../../style/common";
import NodeForm from "./components/NodeForm";

const Node = () => {
  const [node, setNode] = useState<any>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    handleGetNode();
  };
  const handleGetNode = async () => {
    setLoading(true);
    try {
      const resp: any = await axiosInstance.get("/api/node");
      if (resp.status === 200) {
        setNode(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteNode = async (id: any) => {
    try {
      const resp: any = await axiosInstance.get(`/api/node/${id}`);
      if (resp.status === 200) {
        toast.success("Node deleted successfully");
        handleGetNode();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  useEffect(() => {
    handleGetNode();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-8 px-4">
      <div className="max-w-[1600px] mx-auto">
        {/* Header Section */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                Node Management
              </h1>
              <p className="text-gray-600 dark:text-gray-300">
                Organize and manage your nodes efficiently
              </p>
            </div>
          </div>
        </div>

        {/* Loading State */}
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="flex flex-col items-center gap-4">
              <CircularProgress />
              <p className="text-gray-600 dark:text-gray-300">Loading nodes...</p>
            </div>
          </div>
        ) : node?.length === 0 ? (
          <div className="text-center py-20 bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700">
            <div className="flex flex-col items-center gap-4">
              <div className="w-20 h-20 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center">
                <i className="fa-solid fa-network-wired text-3xl text-gray-400 dark:text-gray-500"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                No nodes found
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Get started by creating your first node
              </p>
            </div>
          </div>
        ) : (
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-700">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 tracking-wider">
                      SI No.
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 tracking-wider">
                      Node Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
                  {node?.map((item: any, index: any) => (
                    <tr
                      key={index}
                      className="hover:bg-gray-50 dark:hover:bg-gray-700 transition"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                        {index + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">
                        {item?.node_name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button
                          onClick={() => handleDeleteNode(item?.id)}
                          className="p-2 text-gray-600 dark:text-gray-300 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                          title="Delete node"
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <Modal onClose={handleClose} open={open}>
        <Box sx={modalStyle}>
          <NodeForm onClose={handleClose} />
        </Box>
      </Modal>
    </div>
  );
};

export default Node;
